import { isFormType } from '@fmnts/api/shared';
import { Adapter } from '@fmnts/core';
import { IApiNextFormMinimal } from '../api-model/api-model';
import { NextFormMinimal } from '../model/next-form';
import { ApiRequirementAdapter } from './requirement.adapter';

export class ApiNextFormMinimalAdapter implements Adapter<NextFormMinimal> {
  constructor(private requirementAdapter = new ApiRequirementAdapter()) {}

  adapt(item: IApiNextFormMinimal): NextFormMinimal {
    const { form_type: formType } = item;
    if (!isFormType(formType)) {
      throw new Error(`Unknown form type ${formType}`);
    }

    const requirements = (item.requirements ?? [])
      .filter((requirement) => this.requirementAdapter.canAdapt(requirement))
      .map((req) => this.requirementAdapter.adapt(req));

    return {
      id: item.campaign_id,
      formType,
      modifytime: item.modifytime,
      logo: item.logo,
      name: item.name,
      organizationLogo: item.organization_logo,
      useNextForm: item.use_next_form,
      supportedLanguages: item.supported_languages,
      requirements,
    };
  }
}
